import { render, staticRenderFns } from "./section-group-node.vue?vue&type=template&id=3b142a2f&"
import script from "./section-group-node.vue?vue&type=script&lang=js&"
export * from "./section-group-node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "section-group-node.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/business/select-member/section/section-group-node.vue
// module id = 86
// module chunks = 0